import { type ObjectValuesUnionType } from '../../utils/typing';

export const BasketActionTypes = Object.freeze({
  SET_LOADING_OK: 'BASKET:SET_LOADING_OK',
  ADD_ITEM: 'BASKET:ADD_ITEM',
  ADD_ITEMS: 'BASKET:ADD_ITEMS',
  ADD_BETBUILDER_ITEM: 'BASKET:ADD_BETBUILDER_ITEM',
  ADD_BETBUILDER_ITEM_AS_SIMPLE_BET: 'BASKET:ADD_BETBUILDER_ITEM_AS_SIMPLE_BET',
  DEL_ITEM: 'BASKET:DEL_ITEM',
  SELECTED_FREEBET_CHANGE: 'BASKET:SELECTED_FREEBET_CHANGE',
  SELECTED_BONUS_CHANGE: 'BASKET:SELECTED_BONUS_CHANGE',
  ITEM_STAKE_CHANGE: 'BASKET:ITEM_STAKE_CHANGE',
  ITEM_BANKER_CHANGE: 'BASKET:ITEM_BANKER_CHANGE',
  ITEM_SELECTED_FREEBET_CHANGE: 'BASKET:ITEM_SELECTED_FREEBET_CHANGE',
  ITEM_SELECTED_BONUS_CHANGE: 'BASKET:ITEM_SELECTED_BONUS_CHANGE',
  SET_DEFAULT_STAKE: 'BASKET:SET_DEFAULT_STAKE',
  STAKE_CHANGE: 'BASKET:STAKE_CHANGE',
  SYSTEM_ITEM_SELECTION_CHANGE: 'BASKET:SYSTEM_ITEM_SELECTION_CHANGE',
  SYSTEM_ITEM_SELECTION_RESET: 'BASKET:SYSTEM_ITEM_SELECTION_RESET',
  SAVE: 'BASKET:SAVE',
  CLEAR: 'BASKET:CLEAR',
  RESET: 'BASKET:RESET',
  SWITCH_MODE: 'BASKET:SWITCH_MODE',
  REFRESH: 'BASKET:REFRESH',
  ACCEPT_CHANGES: 'BASKET:ACCEPT_CHANGES',
  SUBMIT: 'BASKET:SUBMIT',
  SUBMIT_OK: 'BASKET:SUBMIT_OK',
  SUBMIT_KO: 'BASKET:SUBMIT_KO',
  SET_SELECTION: 'BASKET:SET_SELECTION',
  GET_SELECTION: 'BASKET:GET_SELECTION',
  SET_ELIGIBLE_FREEBETS: 'BASKET:SET_ELIGIBLE_FREEBETS',
  SET_ELIGIBLE_BOOSTER: 'BASKET:SET_ELIGIBLE_BOOSTER',
  SET_ELIGIBLE_BONUSES: 'BASKET:SET_ELIGIBLE_BONUSES',
  SET_STATUS_OK: 'BASKET:SET_STATUS_OK',
  SET_STATUS_ERROR: 'BASKET:SET_STATUS_ERROR',
  SET_STATUS_WAITING: 'BASKET:SET_STATUS_WAITING',
  SET_STATUS_PENDING: 'BASKET:SET_STATUS_PENDING',
  SET_ITEM_ELIGIBLE_FREEBETS: 'BASKET:SET_ITEM_ELIGIBLE_FREEBETS',
  SET_ITEM_ELIGIBLE_BONUSES: 'BASKET:SET_ITEM_ELIGIBLE_BONUSES',
  SET_ITEM_STATUS_OK: 'BASKET:SET_ITEM_STATUS_OK',
  SET_ITEM_STATUS_ERROR: 'BASKET:SET_ITEM_STATUS_ERROR',
  SET_ITEM_STATUS_WAITING: 'BASKET:SET_ITEM_STATUS_WAITING',
  RECEIVE_FREEBETS: 'BASKET:RECEIVE_FREEBETS',
  RECEIVE_BOOSTERS: 'BASKET:RECEIVE_BOOSTERS',
  RECEIVE_BONUSES: 'BASKET:RECEIVE_BONUSES',
  DEL_FREEBET: 'BASKET:DEL_FREEBET',
  DEL_BONUS: 'BASKET:DEL_BONUS',
  CLEAR_VALIDATED_AND_WAITING: 'BASKET:CLEAR_VALIDATED_AND_WAITING',
  SET_NOTIFICATION: 'BASKET:SET_NOTIFICATION',
  SET_CASHOUT: 'BASKET:SET_CASHOUT',
  VALIDATE_ITEMS: 'BASKET:VALIDATE_ITEMS',
  SET_DEFAULT_BOOSTER_FROM_LICENCE: 'BASKET:SET_DEFAULT_BOOSTER_FROM_LICENCE',
  SET_KEYBOARD: 'BASKET:SET_KEYBOARD',
  SET_FREEBET_BOOLEAN: 'BASKET:SET_FREEBET_BOOLEAN',
  SET_ITEM_FREEBET_BOOLEAN: 'BASKET:SET_ITEM_FREEBET_BOOLEAN',
  SET_KL_ELIGIBLE_COLLECTIBLE: 'BASKET:SET_KL_ELIGIBLE_COLLECTIBLE',
  SET_ITEM_KL_ELIGIBLE_COLLECTIBLE: 'BASKET:SET_ITEM_KL_ELIGIBLE_COLLECTIBLE',
  RESET_KL_ELIGIBLE_COLLECTIBLES: 'BASKET:RESET_KL_ELIGIBLE_COLLECTIBLES',
  SET_IS_GR_ACTIVE: 'BASKET:SET_IS_GR_ACTIVE',
  SET_ITEM_IS_GR_ACTIVE: 'BASKET:SET_ITEM_IS_GR_ACTIVE',
  RESET_ALL_GR_ACTIVES: 'BASKET:RESET_ALL_GR_ACTIVES',
  RECOMPUTE_NEXT_GR_BASKET_STATE: 'RECOMPUTE_NEXT_GR_BASKET_STATE',
  SET_IS_MP_ACTIVE: 'BASKET:SET_IS_MP_ACTIVE',
  SET_ITEM_IS_MP_ACTIVE: 'BASKET:SET_ITEM_IS_MP_ACTIVE',
  SET_ITEM_MP_CARD: 'BASKET:SET_ITEM_MP_CARD',
  DEL_ITEM_MP_CARD: 'BASKET:DEL_ITEM_MP_CARD',
  SET_MP_CARD: 'BASKET:SET_MP_CARD',
  DEL_MP_CARD: 'BASKET:DEL_MP_CARD',
  RESET_ALL_MP_ACTIVES: 'BASKET:RESET_ALL_MP_ACTIVES',
  RECOMPUTE_NEXT_MP_BASKET_STATE: 'BASKET:RECOMPUTE_NEXT_MP_BASKET_STATE',
  OUTCOME_SELECTED: 'BASKET:OUTCOME_SELECTED',
  OUTCOME_UNSELECTED: 'BASKET:OUTCOME_UNSELECTED',
  REQUEST_SWITCH_MODE: 'BASKET:REQUEST_SWITCH_MODE',
  ALTER_CACHED_MM_API_RESPONSE_INFOS: 'BASKET:ALTER_CACHED_MM_API_RESPONSE_INFOS',
  REMOVE_CACHED_MM_API_RESPONSE_INFOS: 'BASKET:REMOVE_CACHED_MM_API_RESPONSE_INFOS',
  UPDATE_ITEM_IS_FROM_MULTICHOICE: 'BASKET:UPDATE_ITEM_IS_FROM_MULTICHOICE',
  UPDATE_ITEM_VALUE: 'BASKET:UPDATE_ITEM_VALUE',
  SANITIZE: 'BASKET:SANITIZE',
  SET_BOOM_IS_ACTIVE: 'BASKET:SET_BOOM_IS_ACTIVE',
  SET_ITEM_BOOM_IS_ACTIVE: 'BASKET:SET_ITEM_BOOM_IS_ACTIVE',
  RESET_BOOM_IS_ACTIVES: 'BASKET:RESET_BOOM_IS_ACTIVES',
  IMPORT_ITEMS: 'BASKET:IMPORT_ITEMS',
});
export type BasketActionType = ObjectValuesUnionType<typeof BasketActionTypes>;
